<template>
	<div class="left_menu">
		<div class="head_wrap">
			<div class="head_box" v-if="userinfo.pid==0">
<!--				<el-upload
					class="avatar-uploader"
					:action="uploadAction"
					:show-file-list="false"
					:on-success="handleAvatarSuccess">
					<img class="vip_tag" src="../../assets/images/vip_tag.png" />
					<img class="head" :src="headImg">
					<p class="icons"><i class="iconfont icon-camera"></i></p>
				</el-upload>-->
        <img class="head" :src="headImg">
			</div>
			<div class="head_box" v-else>
				<img class="vip_tag" src="../../assets/images/vip_tag.png" />
				<img class="head" :src="headImg">
			</div>
			<p class="txt">Hi，{{userinfo.nickname || userinfo.name}}</p>
			<p
                class="user-level-tag"
                :class="`level-${showUserLevel}`"
                >
                {{ showUserLevelText }}
            </p>
			<!-- <p class="viptxt">2022.10.27到期<a href="/vip">去续费</a></p> -->
		</div>
		<ul class="links_list">
			<template v-for="(item,index) in ucmenuList">
				<!-- 有子菜单 -->
				<li v-if="item.children && item.children.length" :key="index" class="has_sub" :class="{open: openMenuIds.includes(item.menu_id)}">
					<a @click="toggleSub(item)"><i class="iconfont" :class="item.icon"></i>{{item.title}}<i class="el-icon-arrow-right sub_arrow"></i></a>
					<ul class="sub_list" v-show="openMenuIds.includes(item.menu_id)">
						<li v-for="(child,ci) in item.children" :key="ci" :class="child.menu_id==curId?'active':''">
							<a @click="onMenu(child)">{{child.title}}</a>
						</li>
					</ul>
				</li>
				<!-- 无子菜单 -->
				<li v-else :key="'m'+index" :class="item.menu_id==curId?'active':''">
					<a @click="onMenu(item)"><i class="iconfont" :class="item.icon"></i>{{item.title}}
            <img src="../../assets/images/hot.png" style="width: 24px;height: 24px;" v-if="item.menu_id==126">
          </a>

				</li>
			</template>
			<li>
				<a @click="outLogin()"><i class="iconfont icon-tuichu"></i>退出登录</a>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapActions,mapMutations,mapState } from "vuex";
import config from "../../assets/js/conf/config";
import headDefault from '../../assets/images/head.png';
export default {
	name: "ucenterMenu",
	props:{
		num:{
			type:String,
			default:'1',

		},
		visible:{
			type:Boolean,
			default:false
		}
	},
	watch:{
		visible(val){
			if(val){
				this.ucmenuList = this.ucmenu?this.ucmenu:[]
			}
		}
	},
	data() {
		return {
			headDefault,
			userinfo:"",
			headImg:"",
			uploadAction:"",
			ucmenuList:[],
			curId:0,
			openMenuIds:[]
		};
	},
	mounted(){

	},
	computed:{
		...mapState({
			users:(state)=>state.login.userinfo,
			avatar:(state)=>state.login.avatar,
			ucmenu:(state)=>state.login.ucmenu,
		}),
        // 等级判断 + 过期判断
        showUserLevel() {
            const { user_level, level_expire_date } = this.userinfo || {}
            const now = Date.now()
            // 没有过期时间 → 普通会员
            if (!level_expire_date) return 9
            // 转换时间
            const expireTime = new Date(level_expire_date).getTime()
            // 已过期 → 普通会员
            if (expireTime < now) return 9
            // 没过期 → 正常等级
            return user_level || 9
        },

        // 等级文字
        showUserLevelText() {
            const level = this.showUserLevel
            if (level === 1) return '企业版会员'
            // if (level === 2) return '企业版会员'
            // if (level === 9) return '普通会员'
            return '普通会员'
        }
	},
	created(){
		this.uploadAction = config.baseApi + '/business/basinessupload'
		if(this.users){
			this.userinfo = this.users
			this.headImg = this.avatar || headDefault
		}
		this.ucmenuList = this.ucmenu?this.ucmenu:[]

		// 如果缓存菜单缺少children结构，从store重新刷新
		let hasChildren = this.ucmenuList.some(item => item.children && item.children.length)
        if (!hasChildren && this.$store.state.login.defaultUcmenu) {
			let defaults = this.$store.state.login.defaultUcmenu
			if(defaults.some(item => item.children && item.children.length)){
				this.$store.commit('login/SET_UCMENU', {is_host: this.$store.state.login.is_host})
				this.ucmenuList = this.$store.state.login.ucmenu
			}
        }
        //隐藏子账号的菜单项
        const hostValue = this.$store.state.login.is_host
        const isSubAccount = hostValue === false || hostValue === 0 || hostValue === '0' || hostValue === 'false'
        if (isSubAccount) {
            if (this.userinfo.access && this.userinfo.access != '000000') {
                const arr = this.userinfo.access.split(',').map(Number).filter(Boolean)
                this.ucmenuList = this.filterMenu(this.ucmenuList, arr)
            } else {
                this.ucmenuList = []
                if (this.userinfo.access === '000000') {
                    this.$message({message: '岗位失效。',type: 'error',});
                }
            }
        }

		// 临时隐藏特定菜单（仅用于测试，生产环境应在后端控制）
		// 隐藏整个运营大厅菜单（menu_id: 134）
		// this.ucmenuList = this.ucmenuList.filter(item => {
		// 	// 过滤掉 menu_id 为 134 的菜单（运营大厅及其所有子菜单）
		// 	if (item.menu_id === 134) return false
		// 	return true
		// })
        this.ucmenuList = this.ucmenuList.filter(item => {
			// 岗位和员工管理菜单 必须是企业合伙人或者合伙人并且员工账号数量大于0
			if (item.menu_id === 129 || item.menu_id === 127){
               if(this.users.user_level === 2 ||(this.users.user_account_num>0 && this.users.user_level === 1)){
                    return true
               }
               return false
            }
			return true
		})

		if(this.$route.query.menuId){
			this.curId = this.$route.query.menuId
		}else{
			this.curId = this.ucmenu[0].menu_id
		}
		// 自动展开包含当前页面的父菜单
		this.ucmenuList.forEach(item => {
			if(item.children && item.children.length){
				let hasActive = item.children.some(c => c.menu_id == this.curId)
				if(hasActive){
					this.openMenuIds.push(item.menu_id)
				}
			}
		})
	},
	methods:{
		...mapActions({
			changeAvatar:"ucenter/changeAvatar",
			getUserinfoData:"login/getUserinfoData",
			getBusinessRoleInfo:"ucenter/getBusinessRoleInfo",
		}),
		...mapMutations({
			OUT_LOGIN:"login/OUT_LOGIN"
        }),

        // 过滤方法（递归，支持多层子菜单）
        filterMenu(menu, ids) {
            return menu.reduce((res, item) => {
                if (item.menu_id === 129 || item.menu_id === 127) return res
                // 如果当前项不在允许列表 → 跳过
                if (!ids.includes(item.menu_id)) return res

                // 保留当前项
                const newItem = { ...item }

                // 如果有子菜单 → 递归过滤
                if (newItem.children && newItem.children.length) {
                    newItem.children = this.filterMenu(newItem.children, ids)
                }

                res.push(newItem)
                return res
            }, [])
        },
		handleAvatarSuccess(res, file) {
			// console.log('ccccccc',res,file)
			this.$alert(`<img src="`+res.data.address+`" style="border-radius:50%;width:300px;height:300px;margin:0 auto;display:block;" />`, '上传头像', {
				dangerouslyUseHTMLString: true,
				showCancelButton:true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(() => {
				this.changeAvatar({data:{
						url:res.data.address,
					},success:(res)=>{
					if(res.code===200){
						console.log('upload success',res)
						this.updateUserinfo()
						this.$message({message: res.msg,type: 'success',});
					} else {
						this.$message({message: res.msg,type: 'error',});
					}
				}})
			}).catch(() => {

			});
		},
		updateUserinfo(){
			this.getUserinfoData({data:{},success:(res)=>{
				if(res.code===200){
					console.log('update userinfo success',res)
					this.headImg = res.data.avatar
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		outLogin(){
			this.$message({message: '已退出登录',type: 'success',});
			this.OUT_LOGIN()
			this.$router.replace('./')
		},
    onMenu(item){
      localStorage.removeItem('importPage')

      // 临时修复：将旧的任务路由映射到新路由
      let targetUrl = item.url
      if (targetUrl === './uc_task/hall') {
        targetUrl = './uc_task_hall'
      } else if (targetUrl === './uc_task/detail') {
        targetUrl = './uc_task_detail'
      }

      // 标准化 URL：移除开头的 ./ 或确保以 / 开头
      if (targetUrl.startsWith('./')) {
        targetUrl = targetUrl.substring(1) // 移除 ./，保留 /
      } else if (!targetUrl.startsWith('/')) {
        targetUrl = '/' + targetUrl
      }

      // 避免重复导航到当前路由
      const targetPath = targetUrl + '?menuId=' + item.menu_id
      const currentPath = this.$route.path
      const currentMenuId = this.$route.query.menuId

      if (currentPath === targetUrl && currentMenuId == item.menu_id) {
        return
      }

      this.$router.push(targetPath).catch(err => {
        // 忽略导航重复错误
        if (err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },
		toggleSub(item){
			let idx = this.openMenuIds.indexOf(item.menu_id)
			if(idx > -1){
				this.openMenuIds.splice(idx, 1)
			}else{
				this.openMenuIds.push(item.menu_id)
			}
		}
	}
}
</script>
<style>
.ucenter_main{align-items: flex-start;}
.right_con{height: 100%;}
</style>
<style scoped>
.left_menu{width: 200px;background: #fff;padding-bottom: 50px;box-sizing: border-box;position: sticky;top: 128px;}
.left_menu .head_wrap{width: 100%;height: 160px;background: #faedee;display: flex;justify-content: center;align-items: center;flex-direction: column;}
.left_menu .head_wrap .head_box{width: 70px;height: 70px;border-radius: 50%;background: #fff;position: relative;cursor: pointer;display: flex;justify-content: center;align-items: center;}
.left_menu .head_wrap .head_box .vip_tag{position: absolute;top: -10px;left: -12px;width: 32px;height: 32px;z-index: 1;}
.left_menu .head_wrap .head_box .icon-touxiang{font-size: 44px;color: #fdaeae;}
.left_menu .head_wrap .head_box .head{border-radius: 50%;position: relative;z-index: 2;width: 70px;height: 70px;}
.left_menu .head_wrap .head_box .icons{width: 20px;height: 20px;border-radius: 50%;background: #f0413e;display: flex;justify-content: center;align-items: center;position: absolute;right: -4px;bottom: 4px;z-index: 2;}
.left_menu .head_wrap .head_box .icons .icon-camera{font-size: 12px;color: #fff;}
.left_menu .head_wrap .txt{line-height: 1;font-weight: bold;margin-top: 14px;font-size: 14px;}
.left_menu .head_wrap .viptxt{line-height: 1;font-size: 12px;color: #666;margin-top: 8px;}
.left_menu .head_wrap .viptxt a{color: #f0413e;margin-left: 6px;}
.left_menu .head_wrap .viptxt a:hover{text-decoration: underline;}
.left_menu .links_list{padding-top: 20px;}
.left_menu .links_list>li{height: 36px;margin-top: 5px;padding: 0 6px;}
.left_menu .links_list>li:first-child{margin-top: 0;}
.left_menu .links_list>li>a{cursor: pointer;width: 100%;height: 100%;display: flex;align-items: center;font-size: 14px;color: #333;border-radius: 4px;box-sizing: border-box;padding: 0 10px;}
.left_menu .links_list>li>a .iconfont{font-size: 16px;margin-right: 12px;}
.left_menu .links_list>li.active>a{color: #f0413e;font-weight: bold;}
.left_menu .links_list>li.active>a .iconfont{font-weight: normal;}
.left_menu .links_list>li>a:active{background: #f2f2f2;}
.left_menu .links_list>li>a:hover{color: var(--red);}

/* 子菜单 */
.left_menu .links_list>li.has_sub{height: auto;margin-top: 8px;}
.left_menu .links_list>li.has_sub>a{height: 36px;font-weight: 500;color: #303133;}
.left_menu .links_list>li.has_sub>a:hover{color: #303133;background: #f5f5f5;}
.left_menu .links_list>li.has_sub>a .sub_arrow{font-size: 12px;color: #999;margin-left: auto;margin-right: 0;transition: transform 0.25s ease;}
.left_menu .links_list>li.has_sub.open>a{color: #f0413e;}
.left_menu .links_list>li.has_sub.open>a .sub_arrow{transform: rotate(90deg);color: #f0413e;}
.left_menu .links_list .sub_list{padding: 2px 0 6px 0;margin: 0;}
.left_menu .links_list .sub_list>li{height: 34px;padding: 0 6px 0 20px;margin-top: 0;}
.left_menu .links_list .sub_list>li>a{cursor: pointer;width: 100%;height: 100%;display: flex;align-items: center;font-size: 13px;color: #666;border-radius: 4px;box-sizing: border-box;padding: 0 10px 0 18px;position: relative;}
.left_menu .links_list .sub_list>li>a::before{content: '';display: block;width: 4px;height: 4px;border-radius: 50%;background: #ccc;position: absolute;left: 6px;top: 50%;transform: translateY(-50%);transition: background 0.2s;}
.left_menu .links_list .sub_list>li>a:hover{background: #fef0f0;color: #f0413e;}
.left_menu .links_list .sub_list>li>a:hover::before{background: #f0413e;}
.left_menu .links_list .sub_list>li.active>a{color: #f0413e;font-weight: bold;background: #fef0f0;}
.left_menu .links_list .sub_list>li.active>a::before{background: #f0413e;width: 6px;height: 6px;}
/* 基础样式 */
.user-level-tag {
  margin-top: 3px;
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  color: #fff;
  text-align: center;
  min-width: 70px;
}

/* 9 = 普通会员 → 灰色简约 */
.user-level-tag.level-9 {
  margin-top: 8px;
  color: #666;
  border: 1px solid #e4e4e4;
}

/* 其他 → 红色警告 */
.user-level-tag.level-other {
  margin-top: 8px;
  background: #F56C6C;
  color: #fff;
}
/* 合伙人高亮 */
.user-level-tag.level-1 {
  margin-top: 8px;
  color: #fec04a;
  border: 1px solid #fec04a;
}

/* 企业合伙人 */
.user-level-tag.level-2 {
  margin-top: 8px;
  color: #fec04a;
  border: 1px solid #fec04a;
}
</style>
